import { render, staticRenderFns } from "./ProductionTypeTag.vue?vue&type=template&id=250fd502&scoped=true&"
import script from "./ProductionTypeTag.vue?vue&type=script&lang=js&"
export * from "./ProductionTypeTag.vue?vue&type=script&lang=js&"
import style0 from "./ProductionTypeTag.vue?vue&type=style&index=0&id=250fd502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250fd502",
  null
  
)

export default component.exports